// JSON-LD builders. Schema must match visible page content.
// No fake reviews, ratings, prices, or claims anywhere.
const SITE = "https://yogatoyacht.com";
const LOGO = "https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?q=80&w=512&auto=format&fit=crop";
const SAME_AS = ["https://instagram.com", "https://twitter.com"];

export const organization = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "YogaToYacht",
  url: `${SITE}/`,
  logo: LOGO,
  description: "A discovery and comparison site for yoga, wellness, sailing and yacht retreats across Europe.",
  sameAs: SAME_AS,
});

export const website = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "YogaToYacht",
  url: `${SITE}/`,
});

// items: [{ name, path }]
export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.path}`,
  })),
});

// faqs: [{ q, a }]
export const faqPage = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const article = ({ title, description, path, date }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  mainEntityOfPage: `${SITE}${path}`,
  author: { "@type": "Organization", name: "YogaToYacht" },
  publisher: { "@type": "Organization", name: "YogaToYacht", logo: { "@type": "ImageObject", url: LOGO } },
  datePublished: date,
  dateModified: date,
});
